import React from "react"
import { useTranslation } from "react-i18next"
import { H2, Paragraph } from "./Styling"
import Photo from "./Photo"
import PhotoContent from "./PhotoContent"

const Contact = () => {
  const [t] = useTranslation("global")

  return (
    <div className="bg-gray-100 pt-16 sm:pt-24 pb-24 sm:pb-32">
      <PhotoContent>
        <div className="sm:w-1/2 text-gray-600 pr-4 pl-4 sm:pl-16">
          <H2>{t("contact.header")}</H2>

          <Paragraph>{t("contact.introduction")}</Paragraph>

          <Paragraph>
            {t("contact.email")}
            <a href="mailto:hello@formatic.nl" className="hover:underline">
              hello@formatic.nl
            </a>
            .
          </Paragraph>
          <Paragraph>
            {t("contact.location1")}
            <a
              className="text-primary"
              href="https://maps.app.goo.gl/rQHyEwnPxRT7yU6g6"
              target="_blank"
              rel="noreferrer"
            >
              Bahialaan 100
            </a>
            {t("contact.location2")}
          </Paragraph>
        </div>

        <Photo align="right" src="/images/contact.jpeg" />
      </PhotoContent>
    </div>
  )
}

export default Contact
